import { CHECKOUT_REQUEST, CHECKOUT_SUCCESS, CHECKOUT_ERROR } from '../constants/ActionTypes'
import type { Action as ReduxAction } from 'redux'

type isCheckingOutAction = ReduxAction<typeof CHECKOUT_REQUEST | typeof CHECKOUT_SUCCESS | typeof CHECKOUT_ERROR>

const isCheckingOut = (state = false, action: isCheckingOutAction) => {
    switch (action.type) {
        case CHECKOUT_REQUEST:
            return true

        case CHECKOUT_SUCCESS:
        case CHECKOUT_ERROR:
            return false

        default:
            return state
    }
}

export default isCheckingOut
